import { Link } from '@inertiajs/react'
import { ChevronRight } from 'lucide-react'

interface Props {
  href: string
  initial: string
  name: string
  meta: React.ReactNode
}

export function ProjectCard ({ href, initial, name, meta }: Props): React.ReactElement {
  return (
    <Link
      href={href}
      className='bg-card border border-(--bp-border) rounded-[10px] px-5.5 py-5 cursor-pointer transition-all flex items-center gap-4 mb-2.5 no-underline hover:border-(--bp-border-s) hover:shadow-[0_2px_12px_rgba(26,35,56,0.07)] hover:-translate-y-px'
    >
      <div className='w-10 h-10 rounded-[9px] bg-accent text-(--bp-accent) flex items-center justify-center shrink-0 text-[16px] font-bold'>
        {initial}
      </div>
      <div className='flex-1 min-w-0'>
        <div className='text-[15px] font-semibold text-(--bp-ink) tracking-[-0.02em] mb-0.75'>{name}</div>
        <div className='text-xs text-(--bp-ink3) flex items-center gap-2'>{meta}</div>
      </div>
      <div className='text-(--bp-ink3) shrink-0'>
        <ChevronRight width={16} height={16} />
      </div>
    </Link>
  )
}
